import { UserFull } from '@wellesley/openapi'
import { getRoute } from '@wellesley/router'

type GetGroupChannelPostPathProps = {
  groupName: string
  channel: Pick<UserFull, 'groupUserName'>
  postId: string
}

export const getGroupChannelPostPath = ({
  groupName,
  channel,
  postId,
}: GetGroupChannelPostPathProps) => {
  return getRoute(`/g/:groupname/@/:channelname/posts/:postId`, {
    groupname: groupName,
    channelname: channel.groupUserName,
    postId,
  })
}
